module.exports = __webpack_public_path__ + "static/media/IconArrow.1aa56590.svg";